import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UnlockYourDreamHome from "./sections/UnlockYourDreamHome";
import MortgageEstimatorTool from "./sections/MortgageEstimatorTool";
import YourPathToOwnership from "./sections/YourPathToOwnership";
import ThePremierAdvantage from "./sections/ThePremierAdvantage";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import SecureYourRate from "./sections/SecureYourRate";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <UnlockYourDreamHome />
      <MortgageEstimatorTool />
      <YourPathToOwnership />
      <ThePremierAdvantage />
      <ClientSuccessStories />
      <SecureYourRate />
      <Footer />
    </div>;
}